"use strict";

import Vue   from 'vue';
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
/*
 let config = {
 // baseURL: process.env.baseURL || process.env.apiUrl || ""
 // timeout: 60 * 1000, // Timeout
 // withCredentials: true, // Check cross-site Access-Control
 };*/
if (!window.json_url) {
    window.json_url = 'http://localhost/judas/judastad_6m_imob_secovi/wp-content/plugins/tirechvue/cadastro/json/'
}
let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // baseURL        : prod ? baseURL : 'http://192.168.111.128',
    // baseURL        : prod ? baseURL : `${location.protocol}//${location.hostname}:3888`,
    // baseURL        : 'http://192.168.111.128',
    timeout        : 60 * 1000, // Timeout
    withCredentials: false, // Check cross-site Access-Control
};

if (process.env.NODE_ENV == 'development') {
    window.tirech_AppConfig = {
        //https://habitacao.secoviunihab.com.br/wp-admin/users.php
        "nonce"       : "f1b86c82b6",
        "xhr_url2"    : "https://habitacao.secoviunihab.com.br\/wp-admin\/admin-ajax.php",
        // "xhr_url" : "https://habitacao.secoviunihab.com.br\/wp-content\/plugins\/tirechvue\/painelprofessor\/leardash_panel_ajax.php",
        "xhr_url"     : "https://habitacao.secoviunihab.com.br\\/wp-content\\/plugins\\/tirechvue\\/cadastro\\/cad_campanhas\\/json/irouter_ajax.php",
        "base_wp"     : "https://habitacao.secoviunihab.com.br",
        "action"      : "cadCampanhas",
        "cadastroCode": 'promob',
        "campanha"    : 1
    };
}
//http://imobiliario.secoviunihab.local/

if (window.json_url) {
    config.baseURL = window.json_url;
}
if (process.env.NODE_ENV == 'production') {
    config.baseURL = window.tirech_AppConfig.xhr_url;
}
else {
    config.baseURL = 'http://imobiliario.secoviunihab.local/wp-admin/admin-ajax.php?action=relatorios'
    config.baseURL = window.tirech_AppConfig.xhr_url;
}

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        if (config && config.data && window.tirech_AppConfig && window.tirech_AppConfig.nonce) {
            config.data.once = window.tirech_AppConfig.nonce;
        }
        if (config && config.params && window.tirech_AppConfig && window.tirech_AppConfig.nonce) {
            config.params.nonce = window.tirech_AppConfig.nonce;
            config.params.action = window.tirech_AppConfig.action;
            // config.params.nonce = window.tirech_AppConfig.nonce;
        }
        if (config) {
            if (config.params) {
                config.params.nonce = window.tirech_AppConfig.nonce;
                config.params.action = window.tirech_AppConfig.action;
                config.params.cadastroCode = window.tirech_AppConfig.cadastroCode;
            }
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        // Do something with response data
        return response;
    },
    function (error) {
        // Do something with response error
        return Promise.reject(error);
    }
);

Plugin.install = function (Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios : {
            get () {
                return _axios;
            }
        },
        $axios: {
            get () {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;
